export default "__VITE_ASSET__DGtIa_iP__"